module.exports = require('./components/cmseditor');
